"use client";

import { HelpSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedHelpSection from "../Components/GeneratedHelpSection";

const Help: FC<HelpSectionProps> = (props) => {
  return <GeneratedHelpSection {...props} />;
};

export default Help;
